<template>
  <div class="club-wrapper">
    <div class="search-desktop">
      <div class="search-desktop-container">
        <CenterSearchBlock :url-key="urlKey" />
      </div>
    </div>
    <BreadCrumbs :current-link="clubTitle" />
    <div class="club-info">
      <div class="header">
        <button class="back-btn" @click="goBack">
          <i class="icon-arrow-back" />
          {{ $t('common.back') }}
        </button>
      </div>
      <div v-if="club" class="club-info-wrapper">
        <TopClubBlock :club="club" :logo-u-r-l="logoURL" />
        <el-collapse v-model="activeNames">
          <el-collapse-item :title="$t('common.trainers')" name="1">
            <Trainers :club="club" />
          </el-collapse-item>
          <el-collapse-item :title="$t('common.shedule')" name="2">
            <ScheduleTable :schedule-obj="scheduleData" />
          </el-collapse-item>
          <el-collapse-item
            :title="`${$t('common.feedbacks')} (${comments.length})`"
            name="3"
          >
            <Feedbacks :entity-id="id" :trainer="false" :comments="comments" />
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div v-if="club" class="club-info desktop">
      <div class="left-block">
        <div class="avatar">
          <img class="avatar" :src="logoURL" alt="club-logo" />
        </div>
        <SocialLinksComponent :links="socialLinks" />
        <div class="clubs-map">
          <MapComponent :markers="clubData" :disable-u-i="true" :zoom="12" />
          <button class="open-map-btn" @click="openMapModal">
            <i class="icon-smallmap-open" />
            {{ $t('common.open_map') }}
          </button>
        </div>
      </div>
      <div class="right-block">
        <TopClubBlock v-if="club" :club="club" />
        <MainClubInfoBlock :id="id" :club="club" />
      </div>
    </div>
    <MapClubsModal :clubs="clubData" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { idFromURL } from '@/dependencies/helpers/id-from-url'
import CenterSearchBlock from '@/components/MainPage/CenterSearchBlock'
import BreadCrumbs from '@/components/Trainer/BreadCrumbs'
import Feedbacks from '@/components/Trainer/parts/Feedbacks'
import TopClubBlock from '@/components/Club/TopClubBlock'
import SocialLinksComponent from '@/components/Common/SocialLinksComponent'
import MainClubInfoBlock from '@/components/Club/MainClubInfoBlock'
import Trainers from '@/components/Club/parts/Trainers'
import MetaHeadMixin from '@/dependencies/mixins/meta-head'
import MapComponent from '@/components/TrainerClubMap/MapComponent'
import MapClubsModal from '@/components/TrainerClubMap/MapClubsModal'
import ScheduleTable from '@/components/Common/Scheduler/parts/SсheduleTable'

export default {
  name: 'ClubPage',
  components: {
    CenterSearchBlock,
    BreadCrumbs,
    Feedbacks,
    TopClubBlock,
    SocialLinksComponent,
    MainClubInfoBlock,
    Trainers,
    MapComponent,
    MapClubsModal,
    ScheduleTable
  },
  mixins: [MetaHeadMixin],
  transition: 'fade-fast',

  async asyncData({ params, app, redirect }) {
    if (!params.id) return redirect('/')
    const { location } = params

    const id = idFromURL(params)
    const config = {
      headers: { 'Content-Language': app.i18n.locale }
    }

    try {
      const {
        data: { data }
      } = await app.$api.PublicApi.getSportClubInfo({ _id: id, config })

      const {
        club: { comments, rating }
      } = data
      await app.store.dispatch('public/UPDATE_COMMENTS', comments)
      await app.store.dispatch('public/SET_RATING', rating)

      return { id, club: data, urlKey: location }
    } catch (e) {
      redirect(app.localePath('location-404'))
      // eslint-disable-next-line no-console
      console.log(e)
    }
  },
  data: () => ({
    activeNames: ['1']
  }),
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      cityDomain: 'seo/getSelectedCity',
      comments: 'public/getComments'
    }),
    clubData() {
      return [this.club?.club]
    },
    clubTitle() {
      return this.club?.club?.title
    },
    socialLinks() {
      return this.club?.club?.social_networks
    },
    scheduleData() {
      return this.club?.club?.scheduleConverted
    },
    logoURL() {
      return this.club?.club?.avatar
        ? this.club?.club?.avatar
        : require(`~/assets/img/noclub-icon-big.jpg`)
    },
    domain() {
      return this.cityDomain?.domainTitle
    },
    metaTitle() {
      return `${this.clubTitle} - ${this.$t('meta.phone_addr_feed')} - ${
        this.domain
      }`
    },
    metaContent() {
      return `${this.$t('meta.info_about')} ${this.clubTitle}.${this.$t(
        'meta.training_sign_up'
      )}`
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    },
    openMapModal() {
      this.$bus.$emit('toggleModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/css/variables';

.club-info {
  &.desktop {
    display: none;
  }

  .header {
    height: 40px;
    padding: 10px;
    border-top: 1px solid #f3f3f3;
    border-bottom: 1px solid #f3f3f3;

    .back-btn {
      color: $gray;
      font-size: 16px;
      display: flex;
      align-items: center;

      i {
        font-size: 18px;
        color: $gray;
        margin-right: 11px;
      }
    }
  }
}

@media (min-width: 768px) {
  .club-info {
    display: none;

    &.desktop {
      display: flex;
      justify-content: space-between;
      max-width: 1180px;
      margin: 0 auto;
      background-color: #fff;
      padding: 30px;

      .left-block {
        width: 27%;

        .avatar {
          img {
            border-radius: 3px;
          }
        }

        .map {
          width: 100%;
          height: 200px;
          background-color: $gray-lighter;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 25px;
          color: $gray;
        }

        .social-links {
          margin: 15px 0;
        }

        .map {
          width: 100%;
          height: 400px;
          background-color: $gray-lighter;
        }

        .clubs-map {
          position: relative;
        }
      }

      .right-block {
        width: 71%;
      }
    }

    .open-map-btn {
      height: 40px;
      line-height: 40px;
      position: absolute;
      bottom: 10px;
      width: 90%;
      left: 10px;
      background-color: $primary;
      color: #ffffff;
      border-radius: 3px;
      font-size: 15px;
      transition: 0.2s linear;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: #35a0aa;
        transition: 0.2s linear;
      }

      i {
        font-size: 18px;
        margin-right: 10px;
      }
    }
  }
}
@media (min-width: 1200px) {
  .club-info {
    .open-map-btn {
      width: 220px;
      left: 40px;
    }
  }
}
</style>
